// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import Footer from "./components/Footer";
import NoticePopup from "./components/NoticePopup";

// 🔐 Firebase auth (for anonymous sign-in)
import { auth } from "./firebaseConfig";
import { onAuthStateChanged, signInAnonymously } from "firebase/auth";

/** Scroll to top on route change */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

function AppShell() {

  // 🔥 GA4 TRACKING FIX (IMPORTANT)
  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-0R43EFZH2D");
    }
  }, []);

  // 🔐 Firebase anonymous login
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (!user) {
        signInAnonymously(auth).catch((e) => {
          console.error("Anonymous sign-in failed:", e);
        });
      }
    });
    return () => unsub();
  }, []);

  return (
    <>
      <ScrollToTop />

      {/* Global notice popup */}
      <NoticePopup />

      <div className="min-h-screen flex flex-col bg-white">
        <main className="flex-1">
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}